<template>
  <button @click="$emit('toggle')">
    <component 
      :is="isOpen ? X : Menu" 
      class="h-6 w-6 text-gray-700"
    />
  </button>
</template>

<script setup lang="ts">
import { Menu, X } from 'lucide-vue-next'

defineProps<{
  isOpen: boolean
}>()

defineEmits<{
  toggle: []
}>()
</script>